import { MapLatLng } from '../models/map.latlng';
import { MapMarker } from '../models/map.marker';
import { MapPoint } from '../models/map.point';
import { MapClusterV2 } from '../movisat/map-cluster-v2';
import { GMapComponent } from './gmap.component';

declare var google: any;

enum Animation {
    BOUNCE = 1,
    DROP = 2
}

export class GMapMarker extends MapMarker {
    private gMap: GMapComponent;
    private iconWidth = 32;
    private iconHeight = 32;

    constructor(id: number, title: string, label: string, content: string, position: MapLatLng, icon: string,
        zIndex: number, map: any, drag: boolean, visible: boolean, gMap: GMapComponent, cluster?: MapClusterV2) {
        super(id, title, label, content, position, icon, zIndex, map, drag, visible, 0, 0, cluster);
        // Mapa en el que se inserta el marcador
        this.gMap = gMap;
        // Si no se ha especificado icono pongo uno por defecto
        if (icon == null || icon.length < 1) {
            icon = 'assets/images/redmarker.png';
        }
        // Si se va a añadir a un cluster el marcador se crea más tarde desde el cluster
        if (!cluster) {
            this.createMarker();
        } else {
            this.marker = null;
        }
    }

    createMarker() {
        this.marker = new google.maps.marker.AdvancedMarkerElement({
            position: this.position,
            title: this.title,
            gmpDraggable: this.drag,
            gmpClickable: true,
            content: this.buildIcon(32, 32),
            zIndex: this.zIndex
        });
        this.marker.visible = this.visible && this.visibleCluster;
        this.marker.label = this.label;
        this.marker.map = this.map;
        this.marker.addListener('click', () => {
            if (this.gMap.infoWindowMarker !== null) {
                this.gMap.infoWindowMarker.close();
            }
            if (this.content.length > 0) {
                this.gMap.infoWindowMarker = new google.maps.InfoWindow({
                    content: this.content
                });
                this.gMap.infoWindowMarker.setZIndex(999);
                this.gMap.infoWindowMarker.open(this.map, this.marker);
                this.gMap.selectedMarker = this.marker;
            }
            this.gMap.onMarkerClick(this.id);
        });
        // Comportamiento por defecto cuando se arrastra un marcador y se deja caer
        this.marker.addListener('dragend', (event: any) => {
            this.position = new MapLatLng(event.latLng.lat(), event.latLng.lng());
            if (this.clusterV2) {
                this.clusterV2.refreshMarker(this);
            }
            this.gMap.onMarkerDragEnd({
                id: this.id,
                position: new MapLatLng(event.latLng.lat(), event.latLng.lng())
            });
        });
        // Comportamiento por defecto cuando se arrastra un marcador
        this.marker.addListener('drag', (event: any) => {
            this.gMap.onMarkerMove({
                id: this.id,
                position: new MapLatLng(event.latLng.lat(), event.latLng.lng())
            });
        });
    }

    buildIcon(width: number, height: number) {
        if (width < 1 || height < 1) {
            width = this.iconWidth;
            height = this.iconHeight;
        } else {
            this.iconWidth = width;
            this.iconHeight = height;
        }
        let div = document.getElementById('mvst-marker-icon-' + this.id);
        if (!div) {
            div = document.createElement("div");
            div.id = 'mvst-marker-icon-' + this.id;
        }
        div.innerHTML = `
            <div style="width: ${width}px; height: ${height}px;>"
                <div style="width: 100%; height: 100%;">
                    <center>
                        <img src="${this.icon}" width="${width}" height="${height}">
                    </center>
                </div>
                <center>
                    <div style="margin-top: -${height / 1.7}px; width: ${width}px;">
                        ${this.label ? this.label : ''}
                    </div>
                <center>
            </div>
            `;
        return div;
    }

    setTitle(title: string) {
        this.title = title;
        if (this.marker) {
            this.marker.title = title;
        }
    }

    setLabel(label: string) {
        this.label = label;
        if (this.marker) {
            this.marker.label = label;
            this.marker.content = this.buildIcon(0, 0);
        }
    }

    setContent(content: string) {
        this.content = content;
        // Si este marcador esta actualmente seleccionado modifico el contenido del info window
        if (this.marker && this.marker === this.gMap.selectedMarker &&
            this.gMap.infoWindowMarker && this.gMap.infoWindowMarker.getMap()) {
            this.gMap.infoWindowMarker.setContent(content);
        }
    }

    setPosition(position: MapLatLng) {
        this.position = position;
        if (this.marker) {
            this.marker.position = position;
        }
        if (this.clusterV2) {
            this.clusterV2.refreshMarker(this);
        }
    }

    setPositionNotRefreshCluster(position: MapLatLng) {
        this.position = position;
        if (this.marker) {
            this.marker.position = position;
        }
    }

    setIcon(icon: string) {
        if (icon == null || icon.length < 1) {
            icon = 'assets/images/redmarker.png';
        }
        this.icon = icon;
        if (this.marker) {
            this.marker.content = this.buildIcon(32, 32);
        }
    }

    setIconEx(icon: string, width: number, height: number, origin: MapPoint, anchor: MapPoint) {
        // Si no se ha especificado icono pongo uno por defecto
        if (icon == null || icon.length < 1) {
            icon = 'assets/images/redmarker.png';
        }
        this.icon = icon;
        if (this.marker) {
            this.marker.content = this.buildIcon(width, height);
        }
    }

    setZIndex(zIndex: number) {
        this.zIndex = zIndex;
        if (this.marker) {
            this.marker.zIndex = zIndex;
        }
    }

    setVisible(visible: boolean) {
        this.visible = visible;
        if (this.clusterV2) {
            this.clusterV2.shouldRefresh();
        } else {
            if (this.marker) {
                this.marker.map = visible ? this.map : null;
            }
        }
    }

    setVisibleFromCluster(visible: boolean) {
        this.visible = visible;
        if (this.clusterV2) {
            if (this.visibleCluster && visible) {
                if (!this.marker) {
                    this.createMarker();
                }
                this.marker.map = visible ? this.map : null;
            } else {
                if (this.marker) {
                    this.marker.map = null;
                }
            }
        } else {
            if (this.marker) {
                this.marker.map = visible ? this.map : null;
            }
        }
    }

    setVisibleCluster(visible: boolean) {
        if (this.clusterV2) {
            this.visibleCluster = visible;
            if (visible) {
                this.setVisibleFromCluster(this.visible);
            } else {
                if (this.marker) {
                    this.marker.map = null; // Destruyo el marcador
                    this.marker = null;
                }
            }
        }
    }

    hide() {
        if (this.marker) {
            this.marker.map = null;
        }
    }

    remove() {
        if (this.clusterV2) {
            this.clusterV2.removeMarker(this, true);
            if (this.marker) {
                this.marker.map = null;
            }
        }
        if (this.marker) {
            this.setVisible(false);
            this.marker = null;
        }
    }

    animate(milisec: number) {
        if (!this.marker) {
            this.createMarker();
        }
        const zi = this.zIndex;
        this.marker.zIndex = 999;
        this.marker.content.classList.add("bounce");
        const t = setTimeout(() => {
            clearTimeout(t);
            if (this.marker) {
                this.marker.zIndex = zi;
                this.marker.content.classList.remove("bounce");
            }
        }, milisec + 3000);
    }

    setDraggable(drag: boolean) {
        this.drag = drag;
        if (this.marker) {
            this.marker.gmpDraggable = drag;
        }
    }
}
